import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import savingsClaimService from "./savingClaimService";
import { flashMessage as flash } from "./../../../utils/flash/index";



const initialState = {
    policyHolder: null,
    isLoading: false,
    isError: false,
    isFiltering: false,
    isUpdated: false,
    isSuccess: false,
    claim_details: null,
    tempCoverInfo: null,
    createSuccess: false,
    approveSuccess: false,
    declineSuccess: false,
    claims: null,
    single_claim: null,
}


const savingsClaimSlice = createSlice({
    initialState,
    name: "savingsClaim",
    reducers: {
      resetSavingsClaim: (state) => initialState,
      setTempCoverInfo: (state, { payload }) => {
          state.tempCoverInfo = payload;
      },
      resetClaimStatus: (state) => {
        state.isError = false;
        state.isSuccess = false;
        state.isLoading = false;
        state.single_cover = null;
        state.createSuccess = false;
        state.updateSuccess = false;
        state.isUpdated = false;
        state.isFetching = false;
        state.isFiltering = false;
        state.isSearching = false;
        state.tempCoverInfo = null;
      },
      resetPolicyHolder: (state) => {
        state.policyHolder = null;
      },
      resetSingleClaims: (state) => {
        state.single_claim = null;
      },
      resetUpdateSuccess: (state) => {
        state.updateSuccess = false;
        state.approveSuccess = false;
        state.declineSuccess = false;
      },
      resetTempCoverInfo: (state) => {
        state.tempCoverInfo = null;
      }
    },
    extraReducers: (builder) => {
      builder
          .addCase(getSavingsPolicyHolder.pending, (state) => {
              state.isLoading = true;
              state.policyHolder = null;
              state.claim_details = null;
              flash("info", "Fetching policy holder information...");
          })
          .addCase(getSavingsPolicyHolder.fulfilled, (state, { payload }) => {
              state.isLoading = false;
              if (!payload.errors) {
              flash("success", "Information fetched successfully...");
              state.policyHolder = payload;
              } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
              } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0];
              flash("error", message);
              }
          })
          .addCase(getSavingsPolicyHolder.rejected, (state, action) => {
              state.isLoading = false;
              state.isError = true;
          })
          .addCase(getSavingsClaimDetails.pending, (state) => {
              state.isLoading = true;
              state.claim_details = null;
              flash("info", "Fetching claim details...");
          })
          .addCase(getSavingsClaimDetails.fulfilled, (state, { payload }) => {
              state.isLoading = false;
              if (!payload.errors) {
                if (payload.message) {
                  flash("info", payload.message);
                  flash("success", "Claim details fetched successfully...");
                } else {
                  flash("success", "Claim details fetched successfully...");
                }
                state.claim_details = payload.data;
              } else if (typeof payload.errors == "string") {
                flash("error", payload.errors);
                state.claim_details = null;
              } else {
                let key = Object.keys(payload.errors)[0];
                let message = payload.errors[key][0];
                flash("error", message);
                state.claim_details = null;
              }
          })
          .addCase(getSavingsClaimDetails.rejected, (state, action) => {
              state.isLoading = false;
              state.isError = true;
          })
          .addCase(createSavingsClaim.pending, (state) => {
              state.isLoading = true;
              // state.claim_details = null;
              flash("info", "Processing Claim...");
          })
          .addCase(createSavingsClaim.fulfilled, (state, { payload }) => {
              state.isLoading = false;
              if (!payload.errors) {
              flash("success", payload.message);
              // state.claim_details = payload.data;
              state.createSuccess = true;
              } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
              } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0];
              flash("error", message);
              }
          })
          .addCase(createSavingsClaim.rejected, (state, action) => {
              state.isLoading = false;
              state.isError = true;
          })
          .addCase(getSavingsClaims.pending, (state) => {
            state.isLoading = true;
            state.isFiltering = true;
            state.isSuccess = false;
          })
          .addCase(getSavingsClaims.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.isFiltering = false;
            state.isFiltered = false;
            if (!payload.errors) {
              state.isSuccess = true;
              state.claims = payload;
            } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
            } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0] || payload.message;
              flash("error", message);
            }
          })
          .addCase(getSavingsClaims.rejected, (state, action) => {
            state.isLoading = false;
            state.isFiltering = false;
            state.isError = true;
          })
          .addCase(getSingleClaim.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getSingleClaim.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            if (!payload.errors) {
              state.single_claim = payload;
            }
          })
          .addCase(getSingleClaim.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
          })
          .addCase(updateSavingsClaim.pending, (state) => {
            state.isLoading = true;
            flash("info", "Updating claim...");
          })
          .addCase(updateSavingsClaim.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            if (!payload.errors) {
              state.isUpdated = true;
              flash("success", payload.message);
            } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
            } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0];
              flash("error", message);
            }
          })
          .addCase(updateSavingsClaim.rejected, (state) => {
            state.isLoading = false;
            state.isError = true;
          })
          .addCase(approveClaim.pending, (state) => {
            state.isLoading = true;
            flash("info", "Processing approval...");
          })
          .addCase(approveClaim.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            if (!payload.errors) {
              console.log('here');
              state.approveSuccess = true;
              console.log(state.approveSuccess);
              flash("success", payload.message);
            } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
            } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0];
              flash("error", message);
            }
          })
          .addCase(approveClaim.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
          })
          .addCase(declineClaim.pending, (state) => {
            state.isLoading = true;
            flash("info", "Processing decline...");
          })
          .addCase(declineClaim.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            if (!payload.errors) {
              state.declineSuccess = true;
              flash("success", payload.message);
            } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
            } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0];
              flash("error", message);
            }
          })
          .addCase(declineClaim.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
          })
    }
})


export const getSavingsPolicyHolder = createAsyncThunk(
    "/savingsClaim/getSavingsPolicyHolder",
    async (data, thunkAPI) => {
      try {
        return await savingsClaimService.getSavingsPolicyHolder(data);
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
);
export const getSavingsClaimDetails = createAsyncThunk(
    "/savingsClaim/getSavingsClaimDetails",
    async (data, thunkAPI) => {
      try {
        return await savingsClaimService.getSavingsClaimDetails(data);
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
);
export const createSavingsClaim = createAsyncThunk(
    "/savingsClaim/createSavingsClaim",
    async (data, thunkAPI) => {
      try {
        return await savingsClaimService.createSavingsClaim(data);
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
);

export const getSavingsClaims = createAsyncThunk(
  "/savingsClaim/getSavingsClaims",
  async (data, thunkAPI) => {
    try {
      return await savingsClaimService.getSavingsClaims(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getSingleClaim = createAsyncThunk(
  "/savingsClaim/getSingleClaim",
  async (data, thunkAPI) => {
    try {
      return await savingsClaimService.getSingleClaim(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateSavingsClaim = createAsyncThunk(
  "/savingsClaim/updateSavingsClaim",
  async (data, thunkAPI) => {
    try {
      return await savingsClaimService.updateSavingsClaim(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const approveClaim = createAsyncThunk(
  "/savingsClaim/approveClaim",
  async (data, thunkAPI) => {
    try {
      return await savingsClaimService.approveClaim(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const declineClaim = createAsyncThunk(
  "/savingsClaim/declineClaim",
  async (data, thunkAPI) => {
    try {
      return await savingsClaimService.declineClaim(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const {
    resetSavingsClaim,
    setTempCoverInfo,
    resetClaimStatus,
    resetPolicyHolder,
    resetSingleClaims,
    resetUpdateSuccess,
    resetTempCoverInfo
} = savingsClaimSlice.actions;

  export default savingsClaimSlice.reducer;